import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TraditionalPattern from '../components/TraditionalPattern';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    telephone: '',
    motDePasse: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.telephone, formData.motDePasse);
    
    if (result.success) {
      // Rediriger vers /admin si l'utilisateur est admin, sinon vers /profile
      if (result.user && result.user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/profile');
      }
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center py-12 px-4">
      {/* Fond artistique avec dégradé */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-800 to-accent-700 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"></div>
      
      {/* Motifs traditionnels en arrière-plan */}
      <div className="absolute inset-0 opacity-10 dark:opacity-5">
        <TraditionalPattern variant="geometric" opacity={0.5} className="text-white" />
      </div>
      
      {/* Éléments décoratifs flottants */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-accent-400/30 dark:bg-accent-600/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary-600/40 dark:bg-primary-800/30 rounded-full blur-3xl animate-pulse delay-1000"></div>
      <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-yellow-400/20 dark:bg-yellow-600/10 rounded-full blur-3xl animate-pulse delay-500"></div>
      
      {/* Carte de connexion */}
      <div className="relative z-10 max-w-md w-full">
        {/* Effet de carte en verre (glassmorphism) */}
        <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20 dark:border-gray-700/50">
          <div className="text-center mb-8">
            {/* Icône décorative */}
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-primary-600 to-primary-800 dark:from-primary-700 dark:to-primary-900 mb-4 shadow-lg">
              <i className="fas fa-user-circle text-white text-4xl"></i>
            </div>
            <h2 className="text-3xl font-display font-bold text-primary-900 dark:text-primary-300">Connexion</h2>
            <p className="text-gray-600 dark:text-gray-400 mt-2">Connectez-vous à votre compte artisan</p>
          </div>

        {error && (
          <div className="bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Numéro de téléphone
            </label>
            <input
              type="tel"
              id="telephone"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              placeholder="77 123 45 67"
            />
          </div>

          <div>
            <label htmlFor="motDePasse" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Mot de passe
            </label>
            <input
              type="password"
              id="motDePasse"
              name="motDePasse"
              value={formData.motDePasse}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              placeholder="Votre mot de passe"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary-800 dark:bg-primary-700 text-white py-3 px-4 rounded-lg font-semibold hover:bg-primary-700 dark:hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Connexion...
              </>
            ) : (
              'Se connecter'
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-gray-600 dark:text-gray-400">
            Pas encore de compte ?{' '}
            <Link to="/register" className="text-primary-800 dark:text-primary-400 hover:text-primary-600 dark:hover:text-primary-300 font-semibold">
              Inscrivez-vous
            </Link>
          </p>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Login;